module.exports = require("@swa-ui/personal-info/src/form/PassengerAccommodationsFormFields/AllergiesFormFields/AllergiesFormFields.module.scss");